import React from 'react';
import { FormBuilder } from 'commons-ui';
import { defaultData } from 'pages/dashboard/lottery/lotteryUploadCsv/utils/constants';
import useUploadCsv from './useAllLotteryActions';
import { FORM_FIELD_CREATE_CONFIG, FORM_LAYOUT_CREATE_CONFIG, validationSchema } from '../../utils/formConfig';

const UploadCsv: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useUploadCsv();

	return (
		<FormBuilder
			data={defaultData}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CREATE_CONFIG}
			layoutConfig={FORM_LAYOUT_CREATE_CONFIG}
		/>
	);
};

export default UploadCsv;
